import ApiStore from './ApiStore';
import axios from 'axios';

class ExternalWorkStore extends ApiStore {

  getWorkdocPreview(preview_id) {
    const request_options = {
      method: 'GET',
      url: '/externalwork/preview_data',
      params: {
        preview_id,
      },
    };
    return this.wrapResponse(axios(request_options));
  }
}

export default new ExternalWorkStore();



// WEBPACK FOOTER //
// ./src/stores/ExternalWorkStore.js